import React, { Component } from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import cn from 'classnames';
import Slider from 'react-slick';
import { withTranslation } from 'react-i18next';
import BuildingCard from 'components/BuildingCard';
import { ROOT_URL } from 'constants/Config';
import { search } from 'actions/building';
import styles from './Suggestions.scss';


class Suggestions extends Component {

  constructor(props) {
    super(props);
    this.state = {
      buildings: []
    };
  }

  componentDidMount() {
    const search = {
      limit: 20,
      orderDirection: 'DESC',
      orderField: 'date_update',
      subregion: [this.props.building.data.subregion.id]
    };
    if (this.props.building.data.type_id == 2) {
      search.typeId = 2;
    }
    this._buildingRequest = setTimeout(() => {
      axios.post(`${ROOT_URL}/buildings/search`, search).then(
        (res) => {
          this._buildingRequest && this.setState({
            buildings: res.data.data.rows.filter(
              building => building.id !== this.props.building.data.id
            )
          });
        }
      );
    }, 0);
  }

  componentWillUnmount = () => {
    this._buildingRequest && clearTimeout(this._buildingRequest);
    this._buildingRequest = null;
  }

  renderItem = (index, key) => (
    <div className={styles.Item} key={key}>
      <BuildingCard {...this.state.buildings[index]} />
    </div>
    )

  handleNextClick = () => {
    this.slider.slickNext();
  }

  handlePrevClick = () => {
    this.slider.slickPrev();
  }

  render() {
    const settings = {
      dots: false,
      arrows: false,
      infinite: false,
      speed: 500,
      slidesToScroll: 5,
      slidesToShow: 5,
      responsive: [
        { breakpoint: 960, settings: { slidesToShow: 3, slidesToScroll: 3 } },
        { breakpoint: 1366, settings: { slidesToShow: 4, slidesToScroll: 4 } }
      ]
    };
    const { building, t } = this.props;
    return (
      this.state.buildings.length ?
        <div className={styles.SectionCarousel}>
          <div className={styles.Container}>
            <p className={styles.SectionCarouselTitle}>
              {building.data.type_id == 2
                ? t('components.building.main.suggestions.jk', {
                  subregion: this.props.building.data.subregion.name
                })
                : t('components.building.main.suggestions.kp', {
                  subregion: this.props.building.data.subregion.name
                })
              }
            </p>
            <div className={styles.Carousel}>
              {(this.state.buildings.length > 3) ? (
                <div className={styles.CarouselArrows}>
                  <div onClick={this.handlePrevClick} className={cn(styles.CarouselArrow, styles.Prev)}></div>
                  <div onClick={this.handleNextClick} className={cn(styles.CarouselArrow, styles.Next)}></div>
                </div>
            ) : (null)}
              <div className={styles.Slides}>
                <Slider ref={c => this.slider = c} {...settings} >
                  {
                  this.state.buildings.map(
                    building => <div key={building.id}><BuildingCard {...building} /></div>
                  )
                }
                </Slider>
              </div>
            </div>
          </div>
        </div> : null
    );
  }
}

export default withTranslation()(connect(null, { search })(Suggestions));



// WEBPACK FOOTER //
// ./src/components/Building/Main/Suggestions/Suggestions.js